import { render, staticRenderFns } from "./OrderGrouped.vue?vue&type=template&id=0d6d0147&"
import script from "./OrderGrouped.vue?vue&type=script&lang=js&"
export * from "./OrderGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports